import { sharedPathes } from '@/shahrzad-assets/shared-routing/pathe'
import WalletChargeSmallDown from './wallet-charge/WalletChargeSmallDown'
import WalletChargeSmallUp from './wallet-charge/WalletChargeSmallUp'
import { getAccessToken, getRefreshToken } from '@/shahrzad-assets/shared-constants/localstorage'
import { useContext, useEffect } from 'react'
import { HomeContext } from '@/shahrzad-assets/shared-contexts/HomeContext'

const WalletCharge = () => {
  const { fetchBalance } = useContext(HomeContext)

  useEffect(() => {
    fetchBalance()
  }, [])

  return (
    <>
      {getRefreshToken() ? <WalletChargeSmallUp /> : null}

      <WalletChargeSmallDown />
    </>
  )
}

export default WalletCharge
